import { ConsumerLoanTargetPath } from '../domain/types';
import { getPath } from '../helpers/url';
import { IFieldState } from '../store/applicationform/applicationFormTypes';

export const dataFormPage = (values: any, formFieldsStates?: IFieldState[], consentFieldStates?: IFieldState[]) => {
    formFieldsStates?.forEach((fieldState) => {
        const name = fieldState.fieldName;
        const value = fieldState.value;
        if (value) {
            if (values[name] && values[name].split) {
                // Do not add duplicate values
                if (values[name].split(';').indexOf(value) === -1) {
                    values[name] = `${values[name]};${value}`;
                }
            } else if (Array.isArray(value)) {
                values[name] = value.join(';');
            } else {
                values[name] = value;
            }
        }
    });

    const consents =
        consentFieldStates
            ?.filter((consentFieldState) => String(consentFieldState.value) === 'true')
            .map((consentFieldState) => {
                const consentParts = consentFieldState.fieldName.split(':');
                if (consentParts.length !== 3) {
                    return undefined;
                }

                return {
                    id: consentParts[2],
                    type: consentParts[1],
                };
            }) ?? [];

    return {
        values,
        consents: consents.filter((consent) => !!consent),
    };
};

export const callbackUrl = (
    target: ConsumerLoanTargetPath,
    language: string,
    countryCode: string,
    applicationReferenceNumber: string,
) => {
    const callbackUrl = window.location.origin;
    return `${callbackUrl}${getPath(target, language, countryCode, applicationReferenceNumber)}`;
};
